var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccMinus28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/minus-28"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 205",
    cx: 14,
    cy: 14.0001,
    r: 13.4,
    stroke: "#3F464C",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 15",
    x1: 7,
    y1: 14.4001,
    x2: 21,
    y2: 14.4001,
    stroke: "#3F464C",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccMinus28);
export default __webpack_public_path__ + "static/media/acc-minus-28.1963320a0dae7612e650a7de0a3112f5.svg";
export { ForwardRef as ReactComponent };